module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3_3.5f67047f.png";